(function(){
  'use strict';
  // mobile menu
  function initMenu(){
    var mt=document.getElementById('mtoggle'), nl=document.getElementById('navlinks');
    if(!mt||!nl) return;
    mt.addEventListener('click',function(){nl.classList.toggle('open');});
    nl.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){nl.classList.remove('open');});});
  }
  // FAQ accordions
  function initFaq(){
    document.querySelectorAll('.q').forEach(function(q){
      q.addEventListener('click',function(){
        var item=q.parentElement, a=item.querySelector('.a'), open=item.classList.contains('open');
        var siblings=item.parentElement.querySelectorAll('.item');
        siblings.forEach(function(i){i.classList.remove('open'); var aa=i.querySelector('.a'); if(aa) aa.style.maxHeight=null;});
        if(!open){item.classList.add('open'); a.style.maxHeight=(a.scrollHeight+40)+'px';}
      });
    });
  }
  // scroll reveal
  function initReveal(){
    if(!('IntersectionObserver' in window)){document.querySelectorAll('.rv').forEach(function(el){el.classList.add('in');});return;}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
    document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
  }
  // quantity steppers
  function initQty(){
    document.querySelectorAll('.qty').forEach(function(q){
      var input=q.querySelector('input');
      var minus=q.querySelector('[data-step="-1"]'), plus=q.querySelector('[data-step="1"]');
      if(minus) minus.addEventListener('click',function(){var v=Math.max(1,(parseInt(input.value)||1)-1);input.value=v;});
      if(plus) plus.addEventListener('click',function(){input.value=(parseInt(input.value)||1)+1;});
    });
  }
  // product image thumbnails
  function initGallery(){
    var main=document.getElementById('pg-main-img');
    if(!main) return;
    document.querySelectorAll('.pg-thumbs img').forEach(function(t){
      t.addEventListener('click',function(){main.src=t.dataset.full||t.src;});
    });
  }
  // product variant -> price + hidden id
  function initVariant(){
    var sel=document.getElementById('variant-select');
    if(!sel) return;
    var priceEl=document.getElementById('pg-price-val');
    sel.addEventListener('change',function(){
      var opt=sel.options[sel.selectedIndex];
      if(priceEl && opt.dataset.price) priceEl.textContent=opt.dataset.price;
      var atc=document.getElementById('atc-btn');
      if(atc){ if(opt.dataset.available==='false'){atc.disabled=true;atc.textContent='Sold Out';} else {atc.disabled=false;atc.textContent=atc.dataset.label||'Add to Cart';} }
    });
  }
  document.addEventListener('DOMContentLoaded',function(){
    initMenu();initFaq();initReveal();initQty();initGallery();initVariant();
  });
})();
